import type { UserInfoResponse } from '../../sdk-client/gen/models/responsesModels/UserInfoResponse'

const isBrowser = () => typeof window !== 'undefined'

const PROFILE_STORAGE_KEY = 'UserProfile'

/**
 * Saves the user profile to local storage.
 * Works with both authentication providers (Email and PointClickCare).
 * 
 * @param profile - The user profile to save, or null to clear the stored profile
 */
export const setUserProfile = (profile?: UserInfoResponse | null): void => {
  if (!isBrowser()) return

  if (!profile) {
    window.localStorage.removeItem(PROFILE_STORAGE_KEY)
    return
  }

  window.localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(profile))
}

/**
 * Retrieves the user profile from local storage.
 * Works with both authentication providers (Email and PointClickCare).
 * 
 * @returns The user profile if it exists, or null if no profile is stored
 */
export const getUserProfile = (): UserInfoResponse | null => {
  if (!isBrowser()) return null

  const stored = window.localStorage.getItem(PROFILE_STORAGE_KEY)
  if (!stored) return null

  try {
    return JSON.parse(stored) as UserInfoResponse
  } catch {
    return null
  }
}

/**
 * Clears the user profile from local storage.
 * Typically used during logout.
 */
export const clearUserProfile = (): void => {
  if (!isBrowser()) return
  window.localStorage.removeItem(PROFILE_STORAGE_KEY)
}
